console.info("Laden des JS-File: Spielschein");

/**
 * @description refresh all week duration radio button container based on subscription state.
 * Adding/Removing class "order-1" moves this element to the bottom, as we don't want
 * conditional input duplicates, which would be sent both when submitting the form, visible or not.
 * 
 * * @returns integer: 0 -> No radio btn checked, 1 -> First (sub) radio btn checked, 2 -> second (non-sub) radio btn checked
 */
 function updateWeekDurationContainer(radioBtnProductSubscription, radioBtnNonProductSubscription, radioBtnJackpotHunter, radioBtnJackpotAbo, containerWochenlaufzeit, advantagesListSub, advantagesListNonSub) {
	console.log("updateWeekDurationContainer");

	var lastSelectedGameDayContainer = $("#spieltage");
	var lastSelectedGameDayLabel = lastSelectedGameDayContainer.data("selected-day");

	var lastSelectedDurationContainer = $("#laufzeit");
	var lastSelectedParticipationPeriod = lastSelectedDurationContainer.data("selected-duration");
	console.log("lastSelectedParticipationPeriod");
	console.log(lastSelectedParticipationPeriod);

	// dauerschein
	if(radioBtnProductSubscription.is(':checked')) {
		$("#laufzeit .laufzeit-label").text("Abbuchungsintervall in Wochen");
		// containerWochenlaufzeit.removeClass("col-sm-10");
		containerWochenlaufzeit.addClass("order-4 col-sm-6 offset-sm-6");
		containerWochenlaufzeit.show();
		advantagesListSub.hide();
		advantagesListNonSub.addClass("shrink-height");
		$("#info-dates").show();
		$('*[data-label="'+ lastSelectedGameDayLabel +'"]').prop("checked", true).trigger("change");
		$('*[data-participation-period="' + lastSelectedParticipationPeriod + '"]').trigger("click");

		return 1;
	}

	// einzelschein
	if(radioBtnNonProductSubscription.is(':checked')) {
		$("#laufzeit .laufzeit-label").text("Laufzeit in Wochen");
		containerWochenlaufzeit.removeClass("order-4 col-sm-6 offset-sm-6");
		// containerWochenlaufzeit.addClass("col-sm-10");
		containerWochenlaufzeit.show();
		advantagesListNonSub.hide();
		advantagesListSub.addClass("shrink-height");
		$("#info-dates").show();
		$('*[data-label="'+ lastSelectedGameDayLabel +'"]').prop("checked", true).trigger("change");
		$('*[data-participation-period="' + lastSelectedParticipationPeriod + '"]').trigger("click");

		return 2;
	}

	// jackpot abo
	if(radioBtnJackpotAbo.is(':checked')) {
		radioBtnJackpotAbo.nextAll(".list-advantages").hide();
		$("#jackpot-million").show();
		containerWochenlaufzeit.hide();
		$("#info-dates").hide();

		$(".next-drawing-day").prop("checked", true).trigger("change");
		lastSelectedGameDayContainer.data("selected-day", lastSelectedGameDayLabel);
		$('*[data-participation-period="1"]').trigger("click");
		lastSelectedDurationContainer.data("selected-duration", lastSelectedParticipationPeriod);
		
		return 3;
	}
	
	// jackpot hunter
	if(radioBtnJackpotHunter.is(':checked')) {
		radioBtnJackpotHunter.nextAll(".list-advantages").hide();
		containerWochenlaufzeit.hide();
		$("#info-dates").show();

		$(".next-drawing-day").prop("checked", true).trigger("change");
		lastSelectedGameDayContainer.data("selected-day", lastSelectedGameDayLabel);
		$('*[data-participation-period="1"]').trigger("click");
		lastSelectedDurationContainer.data("selected-duration", lastSelectedParticipationPeriod);

		return 4;
	}

	return 0;
}

function updateMissingSelectionContainer(containerMissingSelection, validRowCount, radioBtnProductSubscription, radioBtnGrpSubscriptionSelection) {
	console.log("updateMissingSelectionContainer");

	var content = "";
	var isAnySubscriptionOptionSelected =
		radioBtnProductSubscription != null
		&& (radioBtnGrpSubscriptionSelection != 0);

	if(validRowCount < 1 && !isAnySubscriptionOptionSelected) {
		content = "Bitte tippen Sie mindestens ein Feld und wählen unter Laufzeit eine Option aus (Einzelschein, Dauerschein, Jackpot-Abo oder Jackpot-Jäger)";
	} else if (validRowCount < 1) {
		content = "Bitte tippen Sie mindestens ein Feld.";
	} else if (!isAnySubscriptionOptionSelected) {
		content = "Bitte wählen Sie unter Laufzeit eine Option aus (Einzelschein, Dauerschein, Jackpot-Abo oder Jackpot-Jäger)";
	}

	if(content.length > 0 && validRowCount > 0) {
		content += "<br />";
	}

	containerMissingSelection.html(content);
}

function updateInfoRowCountContainer(containerInfoRowCount, validRowCount, scheinTyp) {
	console.log("updateInfoRowCountContainer");

	var rowsName = "";
	var textMinRows = ""
	var themeClass = "";
	var content = "";

	switch (scheinTyp) {
		case "lotto": case "systemschein":
			rowsName = "Lottoreihe";
			themeClass = "";
			break;
		case "eurojackpot":
			rowsName = "Eurojackpot-Reihe";
			themeClass = "eurojackpot-theme";
			break;
	
		default:
			rowsName = "Reihe";
			break;
	}

	// plural (Reihe/n)
	if (validRowCount != 1) {
		rowsName += "n";
	}

	if (validRowCount > 0) {
		content += '<span class="' + themeClass + '"><b>' + validRowCount + ' ' + rowsName + '</b></span>';
	} else {
		content = textMinRows;
	}

	containerInfoRowCount.html(content);
}

function updateInfoExtraGamesContainer(containerInfoExtraGames, selectedSpiel77, selectedSuper6, validRowCount) {
	var textExtraGames = "";

	if(validRowCount <= 0) {
		containerInfoExtraGames.html(' ' + textExtraGames);
		return;
	}

	if (selectedSpiel77) {
		textExtraGames += 'mit <span class="spiel-77"><b>Spiel 77</b></span>';

		if(selectedSuper6)
		{
			textExtraGames += ' und <span class="super6"><b>Super6</b></span>';
		}
	} else if (selectedSuper6) {
		textExtraGames += 'mit <span class="super6"><b>Super6</b></span>';
	}

	containerInfoExtraGames.html(' ' + textExtraGames);
}

function updateInfoDurationContainer(containerInfoDuration, radioBtnGrpSubscriptionSelection, participationPeriod) {
	var participationPeriodString = "";
	var content = "";

	if(radioBtnGrpSubscriptionSelection > 0) {
		if(radioBtnGrpSubscriptionSelection == 1) {
			participationPeriodString = participationPeriod > 1 ? "alle " + participationPeriod + " Wochen" : "einmal pro Woche";
			content += "<b>Dauerschein</b>&nbsp;&ndash;&nbsp;Abbuchung&nbsp;" + participationPeriodString;
		} else if(radioBtnGrpSubscriptionSelection == 2) {
			participationPeriodString = participationPeriod + (participationPeriod > 1 ? " Wochen" : " Woche");
			content += "<b>Einzelschein</b>&nbsp;&ndash;&nbsp;Laufzeit&nbsp;" + participationPeriodString;
		} else if(radioBtnGrpSubscriptionSelection == 3) {
			content += "<b>Jackpot-Abo</b>&nbsp;&ndash;&nbsp;Abbuchung&nbsp;pro Teilnahme, immer wenn die gewünschte Jackpot-Höhe erreicht ist";
		} else if(radioBtnGrpSubscriptionSelection == 4) {
			content += "<b>Jackpot-Jäger</b>&nbsp;&ndash;&nbsp;Abbuchung&nbsp;pro Teilnahme, bis der erste Gewinnrang ausgeschüttet wird";
		}

		content += "<br />";
	}

	containerInfoDuration.html(content);
}

function updateInfoDatesContainer(containerInfoDates, drawingDate, deadline, participation) {
	var content = "";
	var drawingDateParts = drawingDate.split(".");
	var jsDay = new Date(drawingDateParts[2] + "-" + drawingDateParts[1] + "-" +drawingDateParts[0] + "T00:00:00").getDay();
	var shortDay = jsDay == 2 ? "Di." : jsDay == 3 ? "Mi." : jsDay == 5 ? "Fr." : jsDay == 6 ? "Sa." : "";

	content += "<b>Erste Ziehung:</b>&nbsp;"
		+ shortDay
		+ ",&nbsp;"
		+ drawingDate
		+ "&nbsp"
		+ participation
		+ "&nbsp;Uhr"
		+ "&nbsp;&ndash; <b>Annahmeschluss:</b>&nbsp;"
		+ deadline
		+ "&nbsp;Uhr";

	containerInfoDates.html(content);
}

function renderTicketDurationForHessen() {
	if(checkEJForHessen) {
		var btnPartitionPeriod = $('*[data-participation-period="5"]');

		if(btnPartitionPeriod) {
			var chgPartionPeriodActiveState = meinSpielschein.participation_period == 5;

			if(meinSpielschein.spieltagFlash != "k") {
				btnPartitionPeriod.removeClass( "invisible");
			} else {
				if(chgPartionPeriodActiveState) {
					btnPartitionPeriod.removeClass( "active");
					$('*[data-participation-period="4"]').addClass( "active");
					meinSpielschein.participation_period = 4;
				}

				btnPartitionPeriod.addClass( "invisible");
			}
		}
	}
}

(function ($) {

	$.fn.spielschein = function() {

		this.each(function() {
			// durch coldfusion gesetzte: var meinSpielschein
			$this = $(this);
			var spielscheinContainer = $this.find(".spielschein");
			var scheinTyp = spielscheinContainer.data("scheintyp");
			var searchUrlPathForEdit = window.location.pathname.search("bearbeiten");
			var cachedSpielscheinQuestionWrapper = $this.find("#cachedSpielscheinQuestionWrapper");

			var tippfelder = $("#tippfelder");
			var spielscheinEinstellungen = $("#spielschein-einstellungen");
			var blockSpielscheinnummer = spielscheinEinstellungen.find("#block-spielscheinnummer");

			var upperOptions = $("#upperOptions");
			var tippfelderCategory = tippfelder.children().eq(0).data("kategorie");

			var allElements = tippfelder.find(".reihe");
			var allElementsModal = allElements.clone(false);
			var modalSpielschein = $this.find("#modal-spielschein");

			var spielscheinModalCarousel = $("#spielschein-modal-carousel");
			var spielscheinModalCarouselItemWrapper = spielscheinModalCarousel.find("#modalCarousel");

			var containerSpielscheinInfo = $("#spielschein-info");

			// Modal Selectoren
			var btnModalDeleteTipp = modalSpielschein.find("#btn-modal-delete-tipp");
			var btnModalGenerateTipp = modalSpielschein.find("#btn-modal-generate-tipp");
			var btnModalNextRow = modalSpielschein.find("#btn-modal-next-row");
			var btnModalPreviousRow = modalSpielschein.find("#btn-modal-previous-row");
			var btnModalsubmitButton = modalSpielschein.find("#btn-modal-apply");
			var textModalCurrentRow = modalSpielschein.find("#text-modal-current-row");

			// Buttons Spielschein
			var placeholderPreisSpielschein = $this.find("#preis-spielschein");

			var progressbar = btnModalsubmitButton.find("#btnApplyProgressBar");
			var progressbarText = btnModalsubmitButton.find("#btnApplyText");
			var modalCloseButtonLabel = $this.find("#modal-close-button-label");

			var selectModalSpielscheinSystem = $this.find("#modal-spielschein-choosen-system");

			var buttonAlleReihenLeeren = upperOptions.find("#button-alle-reihen-leeren");
			var buttonRefreshValideReihen = upperOptions.find("#button-refresh-valide-reihen");
			var buttonRandomScheinnummer = spielscheinEinstellungen.find("#button-random-scheinnummer");
			var buttonSpielscheinToBasket = $this.find("#button-to-basket");
			var buttonSpielscheinToBasketModal = $this.find("#modal-btn-submit");

			var buttonsTippAdd = upperOptions.find(".tipp-add");
			var buttonsParticipationPeriod = spielscheinEinstellungen.find(".participation-period");
			var radioBtnGrpIsProductSubscription = spielscheinEinstellungen.find('input[type=radio][name="isProductSubscription"]');
			var radioBtnSpieltag = spielscheinEinstellungen.find("#spieltage").find("input[type='radio']");

			var radioBtnProductSubscription = spielscheinEinstellungen.find('#input-productSubscription');
			var radioBtnNonProductSubscription = spielscheinEinstellungen.find('#input-nonSubscription');
			var radioBtnJackpotHunter = spielscheinEinstellungen.find('#input-jackpot-hunter');
			var radioBtnJackpotAbo = spielscheinEinstellungen.find('#input-jackpot-abo');
			var containerWochenlaufzeit = spielscheinEinstellungen.find("#laufzeit");
			var advantagesListSub = radioBtnProductSubscription.nextAll(".list-advantages:first");
			var advantagesListNonSub = radioBtnNonProductSubscription.nextAll(".list-advantages:first");
			var radioBtnGrpSubscriptionSelection = updateWeekDurationContainer(radioBtnProductSubscription, radioBtnNonProductSubscription, radioBtnJackpotHunter, radioBtnJackpotAbo, containerWochenlaufzeit, advantagesListSub, advantagesListNonSub);

			var inputSpiel77 = spielscheinEinstellungen.find("#input-spiel77");
			var inputSuper6 = spielscheinEinstellungen.find("#input-super6");

			var dateTimeStrings = containerSpielscheinInfo.data("dates");

			var containerSpielscheinInfo = spielscheinEinstellungen.find("#spielschein-info");
			var containerInfoExtraGames = spielscheinEinstellungen.find("#info-extra-games");
			var containerMissingSelection = spielscheinEinstellungen.find("#missing-selection");
			var containerInfoRowCount = spielscheinEinstellungen.find("#info-row-count");
			var containerInfoDuration = spielscheinEinstellungen.find("#info-duration");
			var containerInfoDates = spielscheinEinstellungen.find("#info-dates");
			var drawingDate = "";
			var deadline = "";
			var participation = "";

			updateDates(dateTimeStrings);

			// Global Spielschein Data
			var cActiveReiheSystem = tippfelder.children().eq(0).data("system");
			var cActiveReiheMaxAuswahl = Math.floor(getMaxAuswahlReiheBySystem(cActiveReiheSystem));
			var cActiveZusatzReiheMaxAuswahl = getMaxAuswahlZusatzReiheByReihe(cActiveReiheSystem);

			// For "Vollsystem" and "Teilsystem Spielscheine"
			var cActiveReiheScheintypId = null;

			// Data current "Reihe" in Modal
			var jsReihe = null;
			var cActiveReihe = null;
			var cActiveReiheAnzahlAuswahl = null;
			var cActiveZusatzReiheAnzahlAuswahl = null;
			var modalNavigationButtonsDisabled = false;
			var modalCurrentRowIsValid = false;

			var modalReiheFadeTime = 350;
			var modalReiheFadeEasing = "swing"
			var disableNumberClickDuringSlide = false;

			// Define index of jquery objecr where the row starts.
			var domIndexReiheChild = (cActiveReiheSystem == "E05") ? 1 : 0;
			var domIndexZusatzReiheChild = 3;
			var clearReihenDataAfterSystemChanged = true;

			$("#getLocalStorage").on("click", function() {
				console.log("getLocalStorage");
				refreshSpielscheinValuesFromLocalStorage();
			});

			$("#deleteLocalStorage").on("click", function() {
				console.log("deleteLocalStorage");
				deleteSpielscheinValuesFromLocalStorage();
			});

			/**
			 * @description Set local storage values to meinspielschein and refresh the view
			 *
			 * @returns void
			 */
			function refreshSpielscheinValuesFromLocalStorage() {
				console.log("refreshSpielscheinValuesFromLocalStorage");
				cachedSpielscheinQuestionWrapper.hide();
				meinSpielschein = localStorageValues;

				refreshSpielscheinOptions();
				refreshAllSpielscheinReihenAuswahl();
				refreshModalReihen();

				// update participation periods and total amount (only for Lotto)
				if (scheinTyp != "eurojackpot") {
					updateParticipationPeriods();
					refreshLottoTotalAmount();
				}
			}

			/**
			 * @description refresh all Spielschein options by localstotage values
			 *
			 * @returns void
			 */
			function refreshSpielscheinOptions() {
				buttonsParticipationPeriod.removeClass("active").filter('[data-participation-period="'+meinSpielschein.participation_period+'"]').addClass("active");
				$("#spieltage").data("selected-day", meinSpielschein.spieltagFlash);

				if(scheinTyp != "eurojackpot") {
					inputSpiel77.prop( "checked", meinSpielschein.selectedSpiel77);
					inputSuper6.prop( "checked", meinSpielschein.selectedSuper6);
					radioBtnSpieltag.filter('[data-label="'+ meinSpielschein.spieltagFlash +'"]').prop('checked', true);
					var tempTicketNumber =  meinSpielschein.ticketNumber.toString();
					for (var i = 0, len = tempTicketNumber.length; i < len; i += 1) {
						blockSpielscheinnummer.children().eq(i).find("input").val(tempTicketNumber.charAt(i));
					}
				}
			}

			/**
			 * @description Delete local storage values
			 *
			 * @returns void
			 */
			function deleteSpielscheinValuesFromLocalStorage() {
				cachedSpielscheinQuestionWrapper.hide();
				localStorage.removeItem(scheinTyp);
				localStorage[scheinTyp + "RefreshSpielscheinValues"] = 0;
			}

			/**
			 * @description Store the current Spielschein to local storage.
			 *
			 * @return void
			 */
			function storeSpielscheinToLocalStorage() {
				if(searchUrlPathForEdit == -1) {
					console.log("Save Spielscheindata to local storage");
					localStorage[scheinTyp] = JSON.stringify(meinSpielschein);
					localStorage[scheinTyp + "RefreshSpielscheinValues"] = 1;
				}
			}

			// Initial
			wrapAndInjectReihenToModal();
			
			if(searchUrlPathForEdit == -1) {
				var localStorageValues = JSON.parse(localStorage.getItem(scheinTyp));
				if(localStorageValues !== null) {
					if(localStorage[scheinTyp + "RefreshSpielscheinValues"] == 1) {
						console.log("Refresh");
						refreshSpielscheinValuesFromLocalStorage();
						meinSpielschein = localStorageValues;
	
					} else {
						console.log("Ask");
						cachedSpielscheinQuestionWrapper.show();
					}
				}
			} else {
				console.log("Edit Spielschein");
				deleteSpielscheinValuesFromLocalStorage();
				refreshLottoTotalAmount();
			}

			var currentValidRowCount = getCurrentValidRowCount();

			updateInfoExtraGamesContainer(containerInfoExtraGames, meinSpielschein.selectedSpiel77, meinSpielschein.selectedSuper6, currentValidRowCount);
			updateMissingSelectionContainer(containerMissingSelection, currentValidRowCount, radioBtnProductSubscription, radioBtnGrpSubscriptionSelection);
			updateInfoRowCountContainer(containerInfoRowCount, currentValidRowCount, scheinTyp);
			updateInfoDatesContainer(containerInfoDates, drawingDate, deadline, participation);

			var cDateTimeCounterStr = $this.attr("datetime");
			if (cDateTimeCounterStr) {
				$("#spielscheintimer").attr("datetime", cDateTimeCounterStr).countDown({
					with_seconds: false,
					with_hh_leading_zero: false,
					with_mm_leading_zero: false,
					with_ss_leading_zero: false,
					label_dd: " T",
					label_hh: " Std",
					label_mm: " Min",
					label_ss: " Sek",
					separator: " : ",
					separator_days: " : "
				});
			}

			/**
			 * @description Set global values for current "Reihe" in Modal
			 */
			function setCurrentValuesOfModalReihe() {
				console.log("setCurrentValuesOfModalReihe");
				modalCurrentRowIsValid = false;
				cActiveReihe = spielscheinModalCarouselItemWrapper.find(".spielschein-item.active > .reihe");
				textModalCurrentRow.html(cActiveReihe.data("reihe-nr"));
				jsReihe = (cActiveReihe.data("reihe-nr") - 1);

				if (tippfelderCategory == "system") {
					selectModalSpielscheinSystem.val(meinSpielschein.rows[jsReihe].system).change();
					clearReihenDataAfterSystemChanged = true;
				}

				cActiveReiheAnzahlAuswahl = getAnzahlAuswahlByReihe(jsReihe)

				if (cActiveReiheSystem == "E05") {
					cActiveZusatzReiheMaxAuswahl = getMaxAuswahlZusatzReihe(cActiveReiheSystem);
					cActiveZusatzReiheAnzahlAuswahl = getAnzahlAuswahlByReihe(jsReihe, "fields2")
				} else {
					cActiveZusatzReiheMaxAuswahl = null;
					cActiveZusatzReiheAnzahlAuswahl = null;
				}

				if (meinSpielschein.rows[jsReihe].valid) {
					modalCurrentRowIsValid = true;
				}

				toggleModalButtonsByReihe(jsReihe);
				handleBtnProgressBar(jsReihe);
			}

			/**
			 * @description add click event to "Reihe"
			 */
			allElements.on("click", function() {
				console.log("Reihe Clicked");
				clearReihenDataAfterSystemChanged = false;

				setJsReihenNrOfClickedReihe($(this));
				setActiveReiheInsideModalCarousel();
				openSpielscheinModal();
			});

			/**
			 * @description add click event to all nummbers inside a "Reihe"
			 */
			spielscheinModalCarouselItemWrapper.on("click", ".nummer", function() {

				if(disableNumberClickDuringSlide == true) {
					console.log("click disabled");
					return false;
				}

				console.log("Nummer Clicked");
				var clickedNumber = $(this).data("nr");
				var fields = $(this).closest(".inner-border").hasClass("zusatzzahlen") ? "fields2" : "fields";

				if (!$(this).hasClass("auswahl")) {
					if (isSpaceLeftInReihe(jsReihe, fields)) {
						console.log("Noch Platz in der Reihe");
						$(this).addClass("auswahl");
						addAuswahlReihe(jsReihe, clickedNumber, "CU", fields);
						setAnzahlAuswahlByReihe(jsReihe, fields);
					} else {
						console.info("Die Reihe ist schon voll. Was willst du!");

						return false;
					}
				} else {
					$(this).removeClass("auswahl");
					removeAuswahlReihe(jsReihe, clickedNumber, fields);
					setAnzahlAuswahlByReihe(jsReihe, fields);
				}

				modalCurrentRowIsValid = isValidReihe(jsReihe);
				var gesamtAuswahl = cActiveReiheAnzahlAuswahl;

				if(cActiveReiheSystem == "E05") {
					gesamtAuswahl += cActiveZusatzReiheAnzahlAuswahl;
				}

				if (modalCurrentRowIsValid || gesamtAuswahl == 0) {
					if (modalNavigationButtonsDisabled == true) {
						toogleModalNavigationButtons("enable");
						renderSpielscheinReiheAuswahl();

						if (modalCurrentRowIsValid) {
							refreshLottoTotalAmount();
						}
					}
				} else {
					if (modalNavigationButtonsDisabled == false) {
						toogleModalNavigationButtons();
						removeSpielscheinReiheAuswahl();

						if (cActiveReiheAnzahlAuswahl != 1) {
							refreshLottoTotalAmount();
						}
					}
				}

				handleBtnProgressBar(jsReihe);
			});

			/**
			 * @description Sets the global variable (cActiveZusatzReiheAnzahlAuswahl )to the current number of selected numbers
			 * @param {*} reihe
			 * @param {*} fields
			 */
			function setAnzahlAuswahlByReihe(reihe, fields) {
				console.log("setAnzahlAuswahlByReihe");
				if (fields == "fields2") {
					cActiveZusatzReiheAnzahlAuswahl = getGesamtAuswahlByReihe(reihe, fields).length;
				} else {
					if (fields === undefined) {
						fields = "fields";
					}

					cActiveReiheAnzahlAuswahl = getGesamtAuswahlByReihe(reihe, fields).length;
				}
			}

			/**
			 * @description returns the clicked "reihe-nr" from data attribute of clicked object
			 * @param {*} Jquery Object of cliecked "Reihe"
			 *
			 */
			function setJsReihenNrOfClickedReihe(oClickedReihe) {
				console.log("setJsReihenNrOfClickedReihe");
				jsReihe = parseInt(oClickedReihe.closest(".reihe").data("reihe-nr")) - 1;
			}

			/**
			 * @description set courusel-item inside modal to active by given "reihe"
			 */
			function setActiveReiheInsideModalCarousel() {
				console.log("setActiveReiheInsideModalCarousel");
				spielscheinModalCarouselItemWrapper.find(".spielschein-item:eq(" + jsReihe + ")").addClass("active")
				setCurrentValuesOfModalReihe();
			}

			/**
			 * @description Open Spielschein modal
			 */
			function openSpielscheinModal() {
				console.log("openSpielscheinModal");
				modalSpielschein.modal("show");
			}

			/**
			 * @ wrap div carousel-item around "reihe" and inject it to carousel item wrapper
			 */
			function wrapAndInjectReihenToModal() {
				console.log("wrapAndInjectReihenToModal");
				spielscheinModalCarouselItemWrapper.html($(allElementsModal).wrap($('<div class="spielschein-item"/>')).parent());
			}

			/**
			 * @description set click event to next-button. This button trigger the carousel next function
			 */
			btnModalNextRow.on("click", function() {
				console.log("Btn Modal Reihe vor");
				if (!$(this).hasClass("disabled")) {
					disableNumberClickDuringSlide = true;
					spielscheinModalCarouselItemWrapper.children().eq(jsReihe).fadeOut(modalReiheFadeTime, modalReiheFadeEasing, function() {
						$(this).removeClass("active");

						var nextRow = $(this).next();

						if(nextRow.length == 0) {
							nextRow = spielscheinModalCarouselItemWrapper.children().first();
						}

						nextRow.fadeIn(modalReiheFadeTime, modalReiheFadeEasing , function() {
							$(this).addClass("active");
							clearReihenDataAfterSystemChanged = false;
							disableNumberClickDuringSlide = false;
							setCurrentValuesOfModalReihe();
						});
					});
				}
			});

			/**
			 * @description set click event to prev-button. This button trigger the carousel prev function
			 */
			btnModalPreviousRow.on("click", function() {
				console.log("Btn Modal Reihe zurück");
				if (!$(this).hasClass("disabled")) {
					disableNumberClickDuringSlide = true;
					spielscheinModalCarouselItemWrapper.children().eq(jsReihe).fadeOut(modalReiheFadeTime, modalReiheFadeEasing, function() {
						disableNumberClickDuringSlide = true;
						$(this).removeClass("active");

						var prevRow = $(this).prev();

						if(prevRow.length == 0) {
							prevRow = spielscheinModalCarouselItemWrapper.children().last();
						}

						prevRow.fadeIn(modalReiheFadeTime, modalReiheFadeEasing , function() {
							$(this).addClass("active");
							clearReihenDataAfterSystemChanged = false;
							disableNumberClickDuringSlide = false;
							setCurrentValuesOfModalReihe();
						});
					});
				}
			});

			/**
			 * @description set click event to modal delete row button. After Click the current row is cleared
			 */
			btnModalDeleteTipp.on("click", function() {
				console.log("Btn Modal Tipp Löschen");
				if (cActiveReiheAnzahlAuswahl > 0 || cActiveZusatzReiheAnzahlAuswahl > 0) {
					modalCurrentRowIsValid = false;
					clearReihe(jsReihe);
					removeModalReiheAuswahl();
					cActiveReiheAnzahlAuswahl = 0;
					cActiveZusatzReiheAnzahlAuswahl = 0;
					removeSpielscheinReiheAuswahl();
					toggleModalButtonsByReihe(jsReihe);
					handleBtnProgressBar(jsReihe);
					domRemoveValidClassFromRow(jsReihe);
					refreshLottoTotalAmount();
				}
			});

			/**
			 * @description set click event to modal generate tipp button. After Click the row will fill with random numbers
			 */
			btnModalGenerateTipp.on("click", function() {
				console.log("Btn Modal TippGenerieren");
				var ej = cActiveReiheSystem == "E05" ? true : false;
				var result = getSuperPoolRows(cActiveReiheSystem, 1);
				
				if (result.length == 1) {
					clearReihe(jsReihe);
					if (!ej) {
						console.log("if");
						for (var i = 0; i < result[0].length; i++) {
							var cZahl = result[0][i];
							addAuswahlReihe(jsReihe, cZahl, "RU");
						}
					} else {
						for (var i = 0; i < result[0].field_a.length; i++) {
							var cZahl = result[0].field_a[i];
							addAuswahlReihe(jsReihe, cZahl, "RU", "fields");
						}

						for (var i = 0; i < result[0].field_b.length; i++) {
							var cZahl = result[0].field_b[i];
							addAuswahlReihe(jsReihe, cZahl, "RU", "fields2");
						}
					}

					cActiveReiheAnzahlAuswahl = getAnzahlAuswahlByReihe(jsReihe);
					if (cActiveReiheSystem == "E05") {
						cActiveZusatzReiheAnzahlAuswahl = getAnzahlAuswahlByReihe(jsReihe, "fields2");
					}

					modalCurrentRowIsValid = true;

					removeModalReiheAuswahl();
					renderModalReiheAuswahl();
					toggleModalButtonsByReihe(jsReihe);
					handleBtnProgressBar(jsReihe);
					removeSpielscheinReiheAuswahl();
					renderSpielscheinReiheAuswahl();
					refreshLottoTotalAmount();
				}
			});

			/**
			 * @description Deaktivieren/Aktivieren der Blätter und Tipp-Übernehmen-Buttons im Modalfenster
			 *
			 * @param {*} jsReihe
			 * @returns void
			 */
			function toggleModalButtonsByReihe(jsReihe) {
				console.log("toggleModalButtonsByReihe");
				var reiheValid = modalCurrentRowIsValid;
				var leereReihe = cActiveReiheAnzahlAuswahl == 0 ? true : false;
				var reiheValid2 = true;
				var leereReihe2 = true;

				if (cActiveReiheSystem == "E05") {
					console.log("cActiveReiheSystem == E05");
					var reiheValid2 = isValidReihe(jsReihe, "fields2");
					var leereReihe2 = getAnzahlAuswahlByReihe(jsReihe, "fields2") == 0 ? true : false;
				}

				if ((reiheValid && reiheValid2) || (leereReihe && leereReihe2)) {
					toogleModalNavigationButtons("enable");
				} else {
					toogleModalNavigationButtons();
				}
			}

			/**
			 * @description set class auswahl to Spielschein Reihennummer
			 * @param {#} jsReihe
			 */
			function renderSpielscheinReiheAuswahl(jsReiheNr) {
				console.log("renderSpielscheinReiheAuswahl");
				if (jsReiheNr !== undefined) {
					jsReihe = jsReiheNr;
				}

				if(scheinTyp == "systemschein") {
					cActiveReiheMaxAuswahl = getMaxAuswahlReiheBySystem(meinSpielschein["rows"][jsReihe]["system"]);
				}

				cActiveReiheAnzahlAuswahl = meinSpielschein["rows"][jsReihe]["fields"].length;

				for (i = 0; i < cActiveReiheAnzahlAuswahl; i++) {
					var indexOfZahl = (meinSpielschein["rows"][jsReihe]["fields"][i] - 1);
					allElements.eq(jsReihe).children().eq(domIndexReiheChild).children().eq(indexOfZahl).addClass("auswahl")
				}

				if (cActiveReiheSystem == "E05") {
					cActiveZusatzReiheAnzahlAuswahl = meinSpielschein["rows"][jsReihe]["fields2"].length;
					for (i = 0; i < cActiveZusatzReiheAnzahlAuswahl; i++) {
						var indexOfZahl = (meinSpielschein["rows"][jsReihe]["fields2"][i] - 1);
						allElements.eq(jsReihe).children().eq(domIndexZusatzReiheChild).children().eq(indexOfZahl).addClass("auswahl")
					}
				}

				isValidReihe(jsReihe);
			}

			/**
			 * @description refresh all "Spielscheinreihen"
			 */
			function refreshAllSpielscheinReihenAuswahl() {
				console.log("refreshAllSpielscheinReihenAuswahl");
				for (var index = 0; index < meinSpielschein["rows"].length; index++) {
					removeSpielscheinReiheAuswahl(index)
					renderSpielscheinReiheAuswahl(index);
				}
				refreshLottoTotalAmount();
			}

			/**
			 * @description render one modal "Reihe"
			 */
			function renderModalReiheAuswahl() {
				console.log("renderModalReihe:")
				for (i = 0; i < meinSpielschein["rows"][jsReihe]["fields"].length; i++) {
					var indexOfZahl = (meinSpielschein["rows"][jsReihe]["fields"][i] - 1);
					console.log("IndexOfZahl " + indexOfZahl);
					cActiveReihe.children().eq(domIndexReiheChild).children().eq(indexOfZahl).addClass("auswahl");
					console.log(cActiveReihe);
				}

				if (cActiveReiheSystem == "E05") {
					for (i = 0; i < meinSpielschein["rows"][jsReihe]["fields2"].length; i++) {
						var indexOfZahl = (meinSpielschein["rows"][jsReihe]["fields2"][i] - 1);
						console.log("IndexOfZahl " + indexOfZahl)
						cActiveReihe.children().eq(domIndexZusatzReiheChild).children().eq(indexOfZahl).addClass("auswahl")
						console.log(cActiveReihe);
					}
				}
			}

			/**
			 * @description refresh all "Modalreihen"
			 */
			function refreshModalReihen() {
				console.log("refreshModalReihen");
				removeModalAllReihenAuswahl();
				for (i = 0; i < meinSpielschein["rows"].length; i++) {
					var cActiveReiheTmp = spielscheinModalCarouselItemWrapper.children().eq(i).find(".reihe");
					cActiveReiheTmp.children().eq(domIndexReiheChild).children().removeClass("auswahl");
					for (a = 0; a < meinSpielschein["rows"][i]["fields"].length; a++) {
						indexOfZahl = (meinSpielschein["rows"][i]["fields"][a] - 1);
						cActiveReiheTmp.children().eq(domIndexReiheChild).children().eq(indexOfZahl).addClass("auswahl")
					}

					if (cActiveReiheSystem == "E05") {
						console.log(meinSpielschein["rows"][i]["fields2"].length);
						for (b = 0; b < meinSpielschein["rows"][i]["fields2"].length; b++) {
							indexOfZahl = (meinSpielschein["rows"][i]["fields2"][b] - 1);
							cActiveReiheTmp.children().eq(domIndexZusatzReiheChild).children().eq(indexOfZahl).addClass("auswahl");
						}
					}
				}
			}

			/**
			 * @description remove "Spielscheinreihe Auswahl";
			 */
			function removeSpielscheinReiheAuswahl(jsReiheNr) {
				console.log("removeSpielscheinReiheAuswahl");
				if (jsReiheNr !== undefined) {
					jsReihe = jsReiheNr;
				}

				if (cActiveReiheSystem == "E05") {
					allElements.eq(jsReihe).children().eq(1).children().removeClass("auswahl");
					allElements.eq(jsReihe).children().eq(domIndexZusatzReiheChild).children().removeClass("auswahl");
				} else {
					allElements.eq(jsReihe).children().eq(0).children().removeClass("auswahl")
				}
			}

			/**
			 * @description remove "Modalreihe Auswahl"
			 */
			function removeModalReiheAuswahl() {
				console.log("removeModalReiheAuswahl");
				if (cActiveReiheSystem == "E05") {
					cActiveReihe.children().eq(1).children().removeClass("auswahl");
					cActiveReihe.children().eq(domIndexZusatzReiheChild).children().removeClass("auswahl");
				} else {
					cActiveReihe.children().eq(0).children().removeClass("auswahl");
				}
			}

			/**
			 * @description clear complete "Modalreihen"
			 */
			function removeModalAllReihenAuswahl() {
				console.log("removeModalAllReihenAuswahl");
				for (i = 0; i < allElementsModal.length; i++) {
					allElementsModal.eq(i).children().eq(0).children().removeClass("auswahl");
					if(cActiveReiheSystem == "E05") {
						allElementsModal.eq(i).children().eq(domIndexZusatzReiheChild).children().removeClass("auswahl");
					}
				}
			}

			/**
			 * @description Enable or disable ModalmNavigation Buttons
			 *
			 * @param string action
			 */
			function toogleModalNavigationButtons(action) {
				console.log("toogleModalNavigationButtons");
				if (action === undefined) {
					action = "disable"
				}

				if (action == "enable") {
					btnModalNextRow.removeClass("disabled");
					btnModalPreviousRow.removeClass("disabled");
					modalNavigationButtonsDisabled = false;
				} else {
					btnModalNextRow.addClass("disabled");
					btnModalPreviousRow.addClass("disabled");
					modalNavigationButtonsDisabled = true;
				}
			}

			/**
			 * @description Add click event to RandomScheinnumer Button
			 */
			buttonRandomScheinnummer.on("click", function() {
				console.log("Btn click RandomScheinnummer")
				for (var i = 1; i <= 7; i++) {
					$("#input-wahlnummer-" + i).val(Math.floor(Math.random() * 10)).change();
				}
			});

			/**
			 * @description Add event handler for dropdown selectModalSpielscheinSystem
			 */
			selectModalSpielscheinSystem.on("change", function() {
				console.log("selectModalSpielscheinSystem");
				cActiveReiheSystem = $(this).val();
				cActiveReiheScheintypId = $(this).find(":selected").data("scheintyp");
				cActiveReiheMaxAuswahl = getMaxAuswahlReiheBySystem(cActiveReiheSystem);

				setSystemForReihe(jsReihe, cActiveReiheSystem);

				if (clearReihenDataAfterSystemChanged == true) {
					clearReihe(jsReihe);
					removeModalReiheAuswahl();
					cActiveReiheAnzahlAuswahl = 0;
					removeSpielscheinReiheAuswahl();
					isValidReihe(jsReihe);
					toggleModalButtonsByReihe(jsReihe);
					handleBtnProgressBar(jsReihe);
					refreshLottoTotalAmount();
				}
			});

			/**
			 * @description This event is fired when the modal has finished being hidden
			 */
			modalSpielschein.on("hidden.bs.modal", function() {
				console.log("close Modal");
				if (modalNavigationButtonsDisabled) {
					clearReihe(jsReihe);
					removeModalReiheAuswahl();
				}
				spielscheinModalCarouselItemWrapper.children().removeClass("active").attr("style", "");
			});

			/**
			 *  @description Add Eventhandler to button "radioBtnSpieltag"
			 */
			radioBtnSpieltag.on("change", function() {
				console.log("Spieltage.change function");

				updateDates($(this).attr("data-date"));
				meinSpielschein["spieltagFlash"] = $(this).attr("data-label");
				$("#spieltage").data("selected-day", $(this).attr("data-label"));

				// display correct winning plan text
				displayWinningPeriodText(meinSpielschein["spieltagFlash"]);

				// update participation period settings
				if (scheinTyp != "eurojackpot") {
					updateParticipationPeriods();
				}

				refreshLottoTotalAmount();
			});

			function updateParticipationPeriods() {
				var allowedDurationInWeeks = customLottoTicketSettings[meinSpielschein["spieltagFlash"]];

				// hide or show participation period button
				for (var i=1; i<=5; i++) {
					if(allowedDurationInWeeks >= i) {
						buttonsParticipationPeriod.filter('[data-participation-period="' + i + '"]').show();
					} else {
						buttonsParticipationPeriod.filter('[data-participation-period="' + i + '"]').hide();
					}
				}

				// set participation period value "1" active
				if (customLottoTicketSettings[meinSpielschein["spieltagFlash"]] < meinSpielschein["participation_period"]) {
					meinSpielschein["participation_period"] = customLottoTicketSettings[meinSpielschein["spieltagFlash"]];
				}

				buttonsParticipationPeriod.removeClass("active").filter('[data-participation-period="' + meinSpielschein["participation_period"] + '"]').addClass("active");
			}

			/**
			 * @description Add Eventhandler to checkbox "inputSpiel77"
			 */
			inputSpiel77.on("change", function() {
				meinSpielschein["selectedSpiel77"] = $(this).prop("checked") ? true : false;
				
				refreshLottoTotalAmount();
			});

			/**
			 * @description Add Eventhandler to checkbox "inputSuper6"
			 */
			inputSuper6.on("change", function() {
				meinSpielschein["selectedSuper6"] = $(this).prop("checked") ? true : false;

				refreshLottoTotalAmount();
			});

			/**
			 *  @description Add Eventhandler to button "buttonsParticipationPeriod"
			 */
			buttonsParticipationPeriod.on("click", function() {
				meinSpielschein["participation_period"] = $(this).attr("data-participation-period");
				$("#laufzeit").data("selected-duration", $(this).attr("data-participation-period"));

				var currentValidRowCount = getCurrentValidRowCount();

				updateMissingSelectionContainer(containerMissingSelection, currentValidRowCount, radioBtnProductSubscription, radioBtnGrpSubscriptionSelection);
				updateInfoDurationContainer(containerInfoDuration, radioBtnGrpSubscriptionSelection, meinSpielschein.participation_period);

				refreshLottoTotalAmount();
			});

			// jackpot-abo
			$("#jackpot-million").on("change", function (event) {
				meinSpielschein["jackpotAboMinValue"] = $(this).val();
			});

			/**
			 *  @description Add Eventhandler to radio input group "radioBtnGrpIsProductSubscription"
			 */
			radioBtnGrpIsProductSubscription.on("change", function (event) {
				var advantagesLists = $(".list-advantages");
				advantagesLists.addClass("disabled");
				advantagesLists.show();
				advantagesListSub.removeClass("shrink-height");
				$("#jackpot-million").hide();

				radioBtnGrpSubscriptionSelection = updateWeekDurationContainer(radioBtnProductSubscription, radioBtnNonProductSubscription, radioBtnJackpotHunter, radioBtnJackpotAbo, containerWochenlaufzeit, advantagesListSub, advantagesListNonSub);

				meinSpielschein["isJackpotHunter"] = false;
				meinSpielschein["isJackpotAbo"] =  false;
				meinSpielschein["isProductSubscription"] = false;
				meinSpielschein["STARTDATE"] = "";
				meinSpielschein["jackpotAboMinValue"] = 0;

				if(radioBtnGrpSubscriptionSelection == 1) {
					// dauerschein
					meinSpielschein["isProductSubscription"] = true;
				} else if(radioBtnGrpSubscriptionSelection == 2) {
					// einzelschein
				} else if(radioBtnGrpSubscriptionSelection == 3) {
					// jackpotAbo
					meinSpielschein["isProductSubscription"] = true;
					meinSpielschein["jackpotAboMinValue"] = $("#jackpot-million").val();
					meinSpielschein["isJackpotAbo"] = true;
				} else if(radioBtnGrpSubscriptionSelection == 4) {
					// jackpotHunter
					meinSpielschein["isProductSubscription"] = true;
					meinSpielschein["isJackpotHunter"] = true;
				}
				
				if(radioBtnGrpSubscriptionSelection == 3 || radioBtnGrpSubscriptionSelection == 4) {
					radioBtnSpieltag.prop("disabled", true);
				} else {
					radioBtnSpieltag.prop("disabled", false);
				}

				var currentValidRowCount = getCurrentValidRowCount();

				updateMissingSelectionContainer(containerMissingSelection, currentValidRowCount, radioBtnProductSubscription, radioBtnGrpSubscriptionSelection);
				updateInfoDurationContainer(containerInfoDuration, radioBtnGrpSubscriptionSelection, meinSpielschein.participation_period);

				var validRowCountGreaterZero = getCurrentValidRowCount() > 0;
				updateSpielscheinToBasketButton(validRowCountGreaterZero);
			});

			/**
			 *  @description Add Eventhandler to button "buttonSpielscheinToBasket"
			 */
			buttonSpielscheinToBasket.on("click", function(e) {
				console.log(meinSpielschein);

				// executed at new EJ date?
				let drawingDateJS = new Date(drawingDate.split('.').reverse().join('-'));
				let numWeeks = meinSpielschein["participation_period"];

				// we don't want to add the first week here (-1)
				drawingDateJS.setDate(drawingDateJS.getDate() + (7 * (numWeeks -1)));
				let exceedsDateNewEJ = drawingDateJS > ejTuesdayDrawingDate;

				// debug 12DigitsForEJSecondRowDate compare
				console.log("FirstDrawingDate + Weeks: " + drawingDateJS);
				console.log("Last Tuesday before new EJ Friday (22.03. prod) = " + ejTuesdayDrawingDate);
				console.log("First drawing >= new EJ Friday = " + exceedsDateNewEJ);
				console.log("display modal at current date? " + showNewEJModal);

				// duration exceeds last old EJ drawing day?
				if(scheinTyp == "eurojackpot" && exceedsDateNewEJ && showNewEJModal) {
					$("#modal-new-ej").modal("show");

					return;
				} else {
					$(this).prop("disabled", true);
					intoBasket();
				}			
			});

			/**
			 *  @description Add Eventhandler to button "buttonSpielscheinToBasketModal"
			 */
			 buttonSpielscheinToBasketModal.on("click", function(e) {
				$(this).prop("disabled", true);
				
				intoBasket();
			 });

			/**
			 * @description submits basket by calling ajax function "getTippFromSpielscheinForCart"
			 * @returns void
			 */
			 function intoBasket() {
				var resultAjax = $.ajaxHandler({
					"data": meinSpielschein,
					"url": "/ajax/getTippFromSpielscheinForCart/",
					"callback_success": "successTippToCart",
					"callback_error": "errorTippToCart",
					"async": false
				});

				if (resultAjax.success) {
					deleteSpielscheinValuesFromLocalStorage();
					if (resultAjax.relocate.action !== "undefined" && resultAjax.relocate.controller !== "undefined") {
						window.location.replace("/" + resultAjax.relocate.controller + "/" + resultAjax.relocate.action + "/");
					}
				} else {
					console.error("Bei der Einreichung zum Warenkorb ist ein Fehler aufgetreten");
					console.log(resultAjax);
					console.log(resultAjax.result.msg);
				}
			}

			/**
			 * @description Add Eventhandler to button ".wahlnummerinput"
			 */
			$this.delegate(".wahlnummerinput", "change", function() {
				// Bezieht den verändeten Zähler der Scheinnummer und ersetzt bei Vorkommen von Buchstaben diese durch eine beliebige Ziffer
				var cVal = $(this).val().replace(/\D/g, Math.floor(Math.random() * 9 + 1));

				$(this).val(cVal);
				// if ($(this).attr("id") == "input-wahlnummer-7") {
				// 	$this.find("#input-superzahl").val(cVal);
				// }

				setScheinnummerByInputfelder();
				storeSpielscheinToLocalStorage();
			});

			/**
			 * @description Add Eventhandler to button ".wahlpfeil"
			 */
			$this.delegate(".wahlpfeil", "click", function() {
				var cStep = ($(this).hasClass("hoch")) ? 1 : -1;
				var cInput = $(this).parent().find(".wahlnummerinput");
				var newInput = parseInt(cInput.val()) + cStep;
				newInput = getValidSingleScheinnummer(newInput);
				cInput.val(newInput).change();
			});

			/**
			 * @description Replaces all valid Rows in Spielschein with new valid Rows
			 */
			buttonRefreshValideReihen.on("click", function() {
				var ej = cActiveReiheSystem == "E05" ? true : false;
				var maxReihe = allElements.length;
				var gebrauchteReihen = [];

				for (var i = 0; i < maxReihe; i++) {
					if (meinSpielschein.rows[i].fields.length > 0) {
						gebrauchteReihen.push(i);
					}
				}

				var neueReihenAnzahl = gebrauchteReihen.length;
				var result = getSuperPoolRows(cActiveReiheSystem, neueReihenAnzahl);

				for (var i = 0; i < neueReihenAnzahl; i++) {
					if (ej) {
						setAuswahlReihe(gebrauchteReihen[i], result[i].field_a, "RR");
						setAuswahlReihe(gebrauchteReihen[i], result[i].field_b, "RR", "fields2");
					} else {
						setAuswahlReihe(gebrauchteReihen[i], result[i], "RR");
					}
				}

				refreshAllSpielscheinReihenAuswahl();
				refreshModalReihen();
			});

			/**
			 * @description Add click event to "buttonsTippAdd"
			 */
			buttonsTippAdd.on("click", function() {
				var zusaetzlicheReihen = $(this).data("reihen");
				var cSystem = cActiveReiheSystem;
				var ej = cSystem == "E05" ? true : false;
				var result = getSuperPoolRows(cSystem, zusaetzlicheReihen);
				var weitereReihen = true;
				var maxReihe = allElements.length;
				var naechsteReihe = 0;
				var neueReihe = [];

				while (weitereReihen) {
					if (meinSpielschein.rows[naechsteReihe].fields.length == 0) {
						neueReihe = result.shift();

						if (ej) {
							for (var i = 0; i < neueReihe.field_a.length; i++) {
								addAuswahlReihe(naechsteReihe, neueReihe.field_a[i], "RR", "fields");
							}
							for (var i = 0; i < neueReihe.field_b.length; i++) {
								addAuswahlReihe(naechsteReihe, neueReihe.field_b[i], "RR", "fields2");
							}
						} else {
							for (var i = 0; i < neueReihe.length; i++) {
								addAuswahlReihe(naechsteReihe, neueReihe[i], "RR");
							}
						}
					}

					naechsteReihe++;

					if (naechsteReihe >= maxReihe || result.length == 0) {
						weitereReihen = false;
					}
				}

				refreshAllSpielscheinReihenAuswahl();
				refreshModalReihen();
			});

			/**
			 * @description Add click event to "buttonAlleReihenLeeren"
			 */
			buttonAlleReihenLeeren.on("click", function() {
				console.log("buttonAlleReihenLeeren");
				clearAllReihen();
				refreshAllSpielscheinReihenAuswahl();
				refreshModalReihen();
				deleteSpielscheinValuesFromLocalStorage();
			});

			// copy temp Spielschein data into meinSpielschein
			/**
			 * @description Add click event to "btnModalsubmitButton"
			 */
			btnModalsubmitButton.on("click", function() {
				console.log("buttonModalsubmitButton");
				console.log(modalCurrentRowIsValid);

				if (modalCurrentRowIsValid) {
					clearReihenDataAfterSystemChanged = false;
					btnModalNextRow.trigger("click");
				}
			});

			/**
			 * @description Update "Annahmeschluss" and "Erste Teilname" dates.
			 * 				Converts input date to native js
			 *
			 * @returns void
			 */
			function updateDates(dateTimeStrings) {
				var arrDate = dateTimeStrings.split(",");

				drawingDate =arrDate[0];
				deadline = arrDate[1];
				participation = arrDate[2];
			}

			/**
			 * @description Berechnet auf Basis des aktuellen Spielscheins den Preis
			 *
			 * @returns void
			 */
			function refreshLottoTotalAmount() {
				console.log("refreshLottoTotalAmount");

				var currentValidRowCount = getCurrentValidRowCount();

				renderTicketDurationForHessen();

				updateInfoExtraGamesContainer(containerInfoExtraGames, meinSpielschein.selectedSpiel77, meinSpielschein.selectedSuper6, currentValidRowCount);
				updateMissingSelectionContainer(containerMissingSelection, currentValidRowCount, radioBtnProductSubscription, radioBtnGrpSubscriptionSelection);
				updateInfoRowCountContainer(containerInfoRowCount, currentValidRowCount, scheinTyp);
				updateInfoDatesContainer(containerInfoDates, drawingDate, deadline, participation);

				if (currentValidRowCount > 0) {
					storeSpielscheinToLocalStorage();

					var data = {
						"drawingDays": meinSpielschein["spieltagFlash"],
						"duration": meinSpielschein["participation_period"],
						"spiel77": meinSpielschein["selectedSpiel77"],
						"super6": meinSpielschein["selectedSuper6"],
						"lottoReihen": currentValidRowCount,
						"SpielscheinTypId" : meinSpielschein["scheintyp"]
					}

					if (meinSpielschein.scheintyp == 2 || meinSpielschein.scheintyp == 3 || meinSpielschein.scheintyp == 4) {
						var currentValidRowCount = 0;
						var rowSystems = [];

						for (var jsReihe in meinSpielschein["rows"]) {
							if (meinSpielschein.rows[jsReihe].valid == true) {
								rowSystems.push(getSystemByReihe(jsReihe))
								currentValidRowCount++;
							}
						}

						data["lottoReihen"] = currentValidRowCount;
						data["reihenSysteme"] = rowSystems;

					} else if (meinSpielschein.scheintyp == 6) {
						data = {
							"drawingDays": meinSpielschein["spieltagFlash"],
							"duration": meinSpielschein["participation_period"],
							"eurojackpotReihen": getCurrentValidRowCount()
						}
					}

					placeholderPreisSpielschein.html(calculateAmount(data));

					// set active (already checked currentValidRowCount)
    				updateSpielscheinToBasketButton(true);

				} else {
					placeholderPreisSpielschein.html("0,00&nbsp;€");
					updateSpielscheinToBasketButton(false);
					deleteSpielscheinValuesFromLocalStorage();
				}
			}

			/**
			 * @description Updates submit Button 'disabled' state, based on multiple conditions
			 * 
			 * @param {*} validRowCountGreaterZero
			 */
			function updateSpielscheinToBasketButton(validRowCountGreaterZero) {
				console.log("updateSpielscheinToBasketButton");
				
				// enable 'into basket' button, once user selected 'pos' or 'nonPos' 
				var posRadioChecked = radioBtnGrpSubscriptionSelection != 0;
				
				if (validRowCountGreaterZero && posRadioChecked) {
					buttonSpielscheinToBasket.prop("disabled", false);
				} else {
					buttonSpielscheinToBasket.prop("disabled", true);
				}
			}

			/**
			 * @description Prüft ob es sich um einen Systemschein handelt und ob es sich um einen Komboschein handelt
			 * 				Ein Komboschein ist es dann wenn auf einem Spielschein Vollsystemreihen und Teilsystemreihen gespielt wurden.
			 * 				In diesem Fall wird dann eine andere Scheingebühr berechnet
			 *
			 * @returns integer
			 */
			function getSpielscheinTypId() {
				console.log("getSpielscheinTypId");

				var vollsystemschein = false;
				var teilsystemschein = false;

				console.log(meinSpielschein["rows"]);

				for (var jsReihe in meinSpielschein["rows"]) {

					if (meinSpielschein.rows[jsReihe].SystemscheinTypId == 2 && meinSpielschein.rows[jsReihe].valid == true) {
						vollsystemschein = true;
						console.log("SystemscheinTypId: 2");
					}

					if (meinSpielschein.rows[jsReihe].SystemscheinTypId == 3 && meinSpielschein.rows[jsReihe].valid == true) {
						teilsystemschein = true;
						console.log("SystemscheinTypId: 3");
					}
				}

				if(vollsystemschein == true && teilsystemschein == true) {
					// Kombischein
					meinSpielschein["scheintyp"] = 4;
				} else if(vollsystemschein == true) {
					// Vollsystemschein
					meinSpielschein["scheintyp"] = 2;
				} else if(teilsystemschein == true) {
					meinSpielschein["scheintyp"] = 3;
					// Teilsystemschein
				}
			}

			/**
			 * @description Liefert nur valide Einzelziffern einer Scheinnummer zurück
			 *
			 * @param {*} inputNumber
			 *
			 * @returns integer
			 */
			function getValidSingleScheinnummer(inputNumber) {
				return inputNumber > 9 ? 0 : inputNumber < 0 ? 9 : inputNumber;
			}

			/**
			 * @description Setzt die Scheinnummer im JS-Objekt auf Basis der Inputfelder
			 *
			 * @returns void
			 */
			function setScheinnummerByInputfelder() {
				var cScheinNr = [];

				$this.find(".wahlnummerinput").each(function() {
					var cPos = $(this).closest(".wahlnummer").data("wahlnummer-position");

					cScheinNr[cPos - 1] = parseInt($(this).val());
				});
				meinSpielschein["ticketNumber"] = cScheinNr.join("");
			}

			/**
			 * @description fetch Superpool rows
			 *
			 * @param {*} row_type
			 * @param {*} number_of_rows
			 *
			 * @returns array
			 */
			function getSuperPoolRows(row_type, number_of_rows) {
				var inputData = {
					"row_type": row_type,
					"number_of_rows": number_of_rows
				}
				var returnRows = [];

				// Disable submit button
				btnModalGenerateTipp.prop("disabled", true);

				if (row_type == "006" || row_type == "E05") {
					// Trigger ajax request
					var resultAjax = $.ajaxHandler({
						"data": inputData,
						"url": "/ajax/getSuperPoolRows/",
						"callback_success": "successSuperPoolRows",
						"callback_error": "errorSuperPoolRows",
						"async": false
					});

					if (resultAjax.success) {
						returnRows = successSuperPoolRows(resultAjax);
					} else {
						errorSuperPoolRows(resultAjax);
					}
				} else {
					var neededNumbers = parseInt(row_type.slice(-2));
					console.info("🤞 " + neededNumbers + " Glückszahlen werden für diese Reihe benötigt");
					var tempRow = [];
					for (var k = 0; k < number_of_rows; k++) {
						tempRow = [];

						while (tempRow.length < neededNumbers) {
							var newNumber = Math.ceil(Math.random() * 49);
							if (!tempRow.includes(newNumber)) {
								tempRow.push(newNumber);
							}
						}

						tempRow.sort(function (a, b) { return a - b });
						console.info("Zufällig ausgewählt:");
						btnModalGenerateTipp.prop("disabled", false);
						returnRows.push(tempRow);
					}
				}

				return returnRows;
			}

			/**
			 * @description Bring Ajax to the rows
			 *
			 * @param {*} data
			 *
			 * @returns array
			 */
			function successSuperPoolRows(data) {
				if (data.result.components.properties.tips.items) {
					btnModalGenerateTipp.prop("disabled", false);

					return data.result.components.properties.tips.items
				}
			}

			/**
			 * @description Render Error Message and disable submit button
			 *
			 * @param {*} data
			 *
			 * @returns void
			 */
			function errorSuperPoolRows(data) {
				// if a message inside data defined?
				if (typeof data.result.msg !== undefined) {
					// show given error message
					$("#totalAmount").html(data.result.msg);
				} else {
					// No Message... clear innerHtml
					$("#totalAmount").html("");
				}
			}

			/**
			 * @description Liefert die Gesamtanzahl der validen Reihen
			 *
			 * @returns integer
			 */
			function getCurrentValidRowCount() {
				var zaehleValideReihen = 0;

				for (reihe in meinSpielschein["rows"]) {
					if (meinSpielschein["rows"][reihe]["valid"] == true) {
						zaehleValideReihen++;
					}
				}

				return zaehleValideReihen;
			}

			/**
			 * @description gibt die Anzahl der ausgewählten Zahlen für die angefragte Reihe zurück
			 *
			 * @param {*} reihe
			 * @param {*} fields
			 *
			 * @return integer
			 */
			function getAnzahlAuswahlByReihe(reihe, fields) {
				console.log("getAnzahlAuswahlByReihe");
				if (fields === undefined) {
					fields = "fields";
				}

				return getGesamtAuswahlByReihe(reihe, fields).length;
			}

			/**
			 * @description Validiert eine Reihe auf Vollständigkeit
			 *
			 * @param {*} jsReihe
			 *
			 * @returns boolean
			 */
			function isValidReihe(jsReihe) {
				console.log("isValidReihe");
				if (cActiveReiheSystem == "E05") {
					var cActiveReiheMaxAuswahlComplete = cActiveReiheMaxAuswahl + cActiveZusatzReiheMaxAuswahl;
					var cActiveReiheAuswahlComplete = cActiveReiheAnzahlAuswahl + cActiveZusatzReiheAnzahlAuswahl;

					// view Zahlen
					if (cActiveReiheAnzahlAuswahl != cActiveReiheMaxAuswahl) {
						domRemoveValidClassFromRow(jsReihe)
					} else {
						domAddValidClassToRow(jsReihe);
					}

					// View Zusatzzahlen
					if (cActiveZusatzReiheAnzahlAuswahl != cActiveZusatzReiheMaxAuswahl) {
						domRemoveValidClassFromRow(jsReihe)

					} else {
						domAddValidClassToRow(jsReihe);
					}

					// Add flag to Spielcheindata
					if (cActiveReiheMaxAuswahlComplete != cActiveReiheAuswahlComplete) {
						meinSpielschein.rows[jsReihe]["valid"] = false;
						return false;
					}
				} else {
					if (cActiveReiheAnzahlAuswahl != cActiveReiheMaxAuswahl) {

						console.log(cActiveReiheAnzahlAuswahl + "<------>" + cActiveReiheMaxAuswahl);
						meinSpielschein.rows[jsReihe]["valid"] = false;
						console.log("---------------->" + meinSpielschein.rows[jsReihe]["valid"]);
						domRemoveValidClassFromRow(jsReihe)

						return false;
					}

					domAddValidClassToRow(jsReihe);
				}

				meinSpielschein.rows[jsReihe]["valid"] = true;

				if(scheinTyp == "systemschein") {
					meinSpielschein.rows[jsReihe]["SystemscheinTypId"] = cActiveReiheScheintypId;
				}

				return true;
			}

			function domAddValidClassToRow(jsReihe) {
				console.log("domAddValidClassToRow: " + jsReihe);
				if (cActiveReiheSystem == "E05") {

					var tmpReihe = false;
					var tmpZusatzReihe = false;

					if (cActiveReiheAnzahlAuswahl == cActiveReiheMaxAuswahl) {
						allElementsModal.eq(jsReihe).children().eq(domIndexReiheChild).addClass("valide");
						tmpReihe = true;
					}

					if (cActiveZusatzReiheAnzahlAuswahl == cActiveZusatzReiheMaxAuswahl) {
						allElementsModal.eq(jsReihe).children().eq(domIndexZusatzReiheChild).addClass("valide");
						tmpZusatzReihe = true;
					}

					if (tmpReihe && tmpZusatzReihe) {
						allElements.eq(jsReihe).addClass("reihe-valide");
					} else {
						allElements.eq(jsReihe).removeClass("reihe-valide");
					}

				} else {
					allElements.eq(jsReihe).addClass("reihe-valide");
					allElementsModal.eq(jsReihe).addClass("reihe-valide")
				}
			}

			function domRemoveValidClassFromRow(jsReihe) {
				console.log("domRemoveValidClassFromRow: ");
				if (cActiveReiheSystem == "E05") {

					if (cActiveReiheAnzahlAuswahl != cActiveReiheMaxAuswahl) {
						allElementsModal.eq(jsReihe).children().eq(domIndexReiheChild).removeClass("valide");
					}

					if (cActiveZusatzReiheAnzahlAuswahl != cActiveZusatzReiheMaxAuswahl) {
						allElementsModal.eq(jsReihe).children().eq(domIndexZusatzReiheChild).removeClass("valide");

					}
				}

				allElements.eq(jsReihe).removeClass("reihe-valide");
				allElementsModal.eq(jsReihe).removeClass("reihe-valide");
			}

			/**
			 * @description Validiert eine Reihe auf noch freie Plätze
			 *
			 * @param {*} reihe
			 *
			 * @returns boolean
			 */
			function isSpaceLeftInReihe(reihe, fields) {
				console.log("isSpaceLeftInReihe");

				if (fields === undefined) {
					fields = "fields";
				}

				var gesamtAuswahl = getGesamtAuswahlByReihe(reihe, fields);

				if (cActiveReiheSystem == "E05" && fields == "fields2") {
					return gesamtAuswahl.length < 2
				} else {
					return gesamtAuswahl.length < cActiveReiheMaxAuswahl;
				}
			}

			/**
			 * @description Entfernt eine Zahl aus der Reihe
			 *
			 * @param {*} reihe
			 * @param {*} auswahl
			 *
			 * @returns void
			 */
			function removeAuswahlReihe(reihe, auswahl, fields) {
				console.log("removeAuswahlReihe");
				if (fields === undefined) {
					fields = "fields";
				}

				console.log("removeAuswahlReihe > getGesamtAuswahlByReihe");
				var gesamtAuswahl = getGesamtAuswahlByReihe(reihe, fields);
				var pos = gesamtAuswahl.indexOf(auswahl);

				if (pos > -1) {
					gesamtAuswahl.splice(pos, 1);
				}

				if (gesamtAuswahl.length) {
					setAuswahlReihe(reihe, gesamtAuswahl, "CU", fields);
				}
			}

			/**
			 * @description Fügt eine Zahl der Reihe hinzu
			 * 
			 * @param {*} reihe 
			 * @param {*} auswahl
			 * 
			 * @returns void
			 */
			function addAuswahlReihe(reihe, auswahl, tippinput, fields) {
				console.log("addAuswahlReihe");
				if (fields === undefined) {
					fields = "fields";
				}

				var gesamtAuswahl = getGesamtAuswahlByReihe(reihe, fields);

				gesamtAuswahl.push(auswahl);

				setAuswahlReihe(reihe, gesamtAuswahl, tippinput, fields);
			}

			/**
			 * @description Setzt die Auswahl für eine Reihe
			 *
			 * @param {*} reihe
			 * @param {*} auswahl
			 *
			 * @returns void
			 */
			function setAuswahlReihe(reihe, auswahl, tippinput, fields) {
				console.log("setAuswahlReihe");
				if (fields === undefined) {
					fields = "fields";
				}

				if (meinSpielschein.rows[reihe]) {
					meinSpielschein.rows[reihe][fields] = auswahl;
					meinSpielschein.rows[reihe].tippinput = tippinput;
				}
			}

			/**
			 * @description Leert eine Reihe
			 *
			 * @param {*} reihe 
			 * 
			 * @returns void
			 */
			function clearReihe(reihe) {
				console.log("clearReihe");
				if (meinSpielschein.rows[reihe]) {
					meinSpielschein.rows[reihe].fields = [];
					meinSpielschein.rows[reihe].valid = false;
					meinSpielschein.rows[reihe].tippinput = "CU";

					if (meinSpielschein.rows[reihe].fields2) {
						meinSpielschein.rows[reihe].fields2 = [];
					}
				}
			}

			function clearAllReihen() {
				console.log("clearAllReihen");
				for (var i = 0; i < meinSpielschein["rows"].length; i++) {
					clearReihe(i);
				}
			}

			/**
			 * @description Gibt die maximale Anzahl an auswählbaren Zahlen für eine Reihe zurück
			 * 
			 * @param {*} system
			 * 
			 * @returns int
			 */
			function getMaxAuswahlReiheBySystem(system) {
				console.log("getMaxAuswahlReiheBySystem");
				var maxSelectableNumbersBySystem = -1;

				if (
					!isNull(gebuehrenMatrix[system])
					&& system.substring(1, 1) != "S"
				) {
					maxSelectableNumbersBySystem = system.slice(-2);
				}

				return maxSelectableNumbersBySystem;
			}

			/**
			 * @description Gibt die maximale Anzahl an auswählbaren Zahlen für eine Zusatzreihe zurück
			 *
			 * @param {*} system
			 *
			 * @returns int
			 */
			function getMaxAuswahlZusatzReihe(system) {
				console.log("getMaxAuswahlZusatzReihe");
				var maxSelectableNumbersBySystem = -1;

				if (system == "E05") {
					maxSelectableNumbersBySystem = 2;
				}

				return maxSelectableNumbersBySystem;
			}

			/**
			 * @description gibt das System einer Reihe zürück
			 *
			 * @param {*} reihe
			 *
			 * @returns string
			 */
			function getSystemByReihe(reihe) {
				console.log("getSystemByReihe");
				if (meinSpielschein.rows[reihe]) {
					return !isNull(meinSpielschein.rows[reihe].system) ? meinSpielschein.rows[reihe].system : meinSpielschein.system;
				}
			}

			/**
			 * @description setzt in der angegebenen Reihe das Spielsystem
			 * 
			 * @param {*} jsReihe
			 * @param {*} spielSystem
			 * 
			 * @returns void
			 */
			function setSystemForReihe(jsReihe, spielSystem) {
				console.log("setSystemForReihe");
				meinSpielschein.rows[jsReihe].system = spielSystem;
			}

			/**
			 * @description gibt die Gesamtauswahl einer Reihe zurück
			 * 
			 * @param {*} reihe 
			 * @param {*} field
			 * 
			 * @returns array
			 */
			function getGesamtAuswahlByReihe(reihe, fields) {
				console.log("getGesamtAuswahlByReihe");
				if (fields === undefined) {
					fields = "fields";
				}

				if (meinSpielschein.rows[reihe]) {
					return meinSpielschein.rows[reihe][fields];
				}
			}

			/**
			 * @description Gibt die maximale Anzahl der auswählbaren Zahlen einer Zusatzreihe zurück
			 *
			 * @param {*} reihe
			 *
			 * @returns int
			 */
			function getMaxAuswahlZusatzReiheByReihe(reihe) {
				//console.log("getMaxAuswahlZusatzReiheByReihe");
				if (meinSpielschein.rows[reihe]) {
					return !isNull(meinSpielschein.rows[reihe].maxAuswahlZusatzReihe) ? meinSpielschein.rows[reihe].maxAuswahlZusatzReihe : -1;
				} else {
					return 2;
				}
			}

			/**
			 * @description prüft das Vorhandensein einer Variable
			 *
			 * @param {*} variable
			 *
			 * @returns boolean
			 */
			function isNull(variable) {
				return typeof variable === "undefined" || variable === null;
			}

			/**
			 * @description steuert den Fortschrittverlauf auf dem übernehmen Button im Modal
			 *
			 * @param {*} reihe
			 *
			 * @returns boolean
			 */
			function handleBtnProgressBar() {
				console.log("handleBtnProgressBar");

				if (cActiveReiheSystem != "E05") {
					cActiveZusatzReiheMaxAuswahl = 0;
					cActiveZusatzReiheAnzahlAuswahl = 0;
				}

				var maxAuswahlReihe = Math.floor(cActiveReiheMaxAuswahl);
				var auswahlReihe = cActiveReiheAnzahlAuswahl;
				var maxAuswahlReihen = maxAuswahlReihe + cActiveZusatzReiheMaxAuswahl;
				var auswahlReihen = auswahlReihe + cActiveZusatzReiheAnzahlAuswahl;
				var progess = Math.floor((auswahlReihen * 100) / maxAuswahlReihen);

				if (auswahlReihe == 0 && cActiveZusatzReiheAnzahlAuswahl == 0) {
					progressbar.css("width", "");

					if (btnModalsubmitButton.hasClass("has-number")) {
						btnModalsubmitButton.toggleClass("no-number has-number");
						progressbarText.removeClass("complete");
						progressbar.toggleClass("in-progress complete");
					}

					renderRestZahlenTerm(cActiveReiheSystem, maxAuswahlReihe, auswahlReihe, cActiveZusatzReiheMaxAuswahl, cActiveZusatzReiheAnzahlAuswahl);
					modalCloseButtonLabel.html("Schließen");

				} else if (auswahlReihe == maxAuswahlReihe && cActiveZusatzReiheMaxAuswahl == cActiveZusatzReiheAnzahlAuswahl) {
					btnModalsubmitButton.removeClass("no-number").addClass("has-number");
					progressbar.removeClass("in-progress").addClass("complete");
					progressbarText.html("Feld ausgefüllt, weiter");
					modalCloseButtonLabel.html("Übernehmen und schließen");
					progressbar.css("width", progess + "%");
				} else {

					if (btnModalsubmitButton.hasClass("no-number")) {
						btnModalsubmitButton.toggleClass("no-number has-number");
					}

					if (progressbar.hasClass("complete")) {
						progressbarText.removeClass("complete");
						progressbar.toggleClass("in-progress complete");
					}

					progressbar.animate({ width: (progess * btnModalsubmitButton.width() / 100) }, 0);
					renderRestZahlenTerm(cActiveReiheSystem, maxAuswahlReihe, auswahlReihe, cActiveZusatzReiheMaxAuswahl, cActiveZusatzReiheAnzahlAuswahl);
					modalCloseButtonLabel.html("Schließen");
				}
			}

			/**
			 * @description renders the term "noch x Zahl(en)" for Lotto and "noch x Zahlen und y Zusatzzahl(en)" for Eurojackpot
			 *
			 * @param {*} cActiveReiheSystem
			 * @param {*} maxAuswahlReihe
			 * @param {*} auswahlReihe
			 * @param {*} cActiveZusatzReiheMaxAuswahl
			 * @param {*} cActiveZusatzReiheAnzahlAuswahl
			 *
			 * @returns void
			 */
			function renderRestZahlenTerm(cActiveReiheSystem, maxAuswahlReihe, auswahlReihe, cActiveZusatzReiheMaxAuswahl, cActiveZusatzReiheAnzahlAuswahl) {
				var restZahlen = maxAuswahlReihe - auswahlReihe;
				var termZahl = restZahlen == 1 ? " Zahl" : " Zahlen";
				var restZahlenZusatz = "";
				var termZahlZusatz = "";
				var termUnd = "";

				if (cActiveReiheSystem == "E05") {
					termUnd = " und ";
					restZahlenZusatz = cActiveZusatzReiheMaxAuswahl - cActiveZusatzReiheAnzahlAuswahl;
					termZahlZusatz = restZahlenZusatz == 1 ? " Eurozahl" : " Eurozahlen";

					// unset first term part next to "noch"
					if (restZahlen == 0) {
						restZahlen = "";
						termZahl = "";
						termUnd = "";
					}

					// unset second term part before to "termUnd"
					if (restZahlenZusatz == 0) {
						termUnd = "";
						restZahlenZusatz = "";
						termZahlZusatz = "";
					}

				}

				progressbarText.html("Noch " + restZahlen + termZahl + termUnd + restZahlenZusatz + termZahlZusatz);
			}

		})
	}

	// countdown, if element exists
	if(document.getElementById("countdown-container")){

		var tickInterval = 1000; // default refresh rate (1 second)
		var deadlineContainer = document.getElementById("countdown-container"); // main deadline container
		var daysContainer = document.getElementById("deadline-days"); // days container
		var daysFirstDigitContainer = daysContainer.firstElementChild;
		var daysUnitContainer = daysContainer.nextElementSibling;
		var hoursContainer = document.getElementById("deadline-hours"); // hours container
		var hoursFirstDigitContainer = hoursContainer.firstElementChild;
		var hoursLastDigitContainer = hoursContainer.lastElementChild;
		var hoursUnitContainer = hoursContainer.nextElementSibling;
		var minutesContainer = document.getElementById("deadline-minutes"); // minutes container
		var minutesFirstDigitContainer = minutesContainer.firstElementChild;
		var minutesLastDigitContainer = minutesContainer.lastElementChild;
		var minutesUnitContainer = minutesContainer.nextElementSibling;

		var deadlineDateString = deadlineContainer.getAttribute('data-deadline-date');
		var countDownDate = new Date(deadlineDateString).getTime(); // Get the date we're counting down to (from main deadline container)


		var nowDateString = deadlineContainer.getAttribute('data-now-date');
		//var nowDateString = "2019-05-15T17:17:00Z";

		var now = new Date(nowDateString).getTime(); // get the current server time
		var distance = countDownDate - now;

		var restartTimer = true;
		var lastSecondTimer = true;

		var days = 0;
		var hours = 0;
		var minutes = 0;
		var seconds = 0;

		if(distance <= 61000) {
			tickInterval = 1000;
			restartTimer = false;
			lastSecondTimer = false;
		} else {
			var tmpCurrentDate = new Date(nowDateString);
			var tmptickInterval = tmpCurrentDate.getSeconds();
			if(tmptickInterval == 0) {
				tickInterval = 1000;
			} else {
				tmptickInterval = 60 - tmptickInterval;
				tmptickInterval = tmptickInterval + 1;
				tickInterval  = tmptickInterval * 1000;
			}
		}

		refreshTimerView();
		var intervalID = window.setInterval(timerCallback, tickInterval);

		function refreshTimerView() {
			days = Math.floor(distance / (1000 * 60 * 60 * 24));
			hours = pad2(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
			minutes = pad2(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
			seconds = pad2(Math.floor((distance % (1000 * 60)) / 1000));

			daysFirstDigitContainer.innerHTML = days;
			daysUnitContainer.innerHTML = days == 1 ? "Tag" : "Tage";

			hoursFirstDigitContainer.innerHTML = hours.slice(0,1);
			hoursLastDigitContainer.innerHTML = hours.slice(-1);
			hoursUnitContainer.innerHTML = hours == 1 ? "Stunde" : "Stunden";

			minutesFirstDigitContainer.innerHTML = minutes.slice(0,1);
			minutesLastDigitContainer.innerHTML = minutes.slice(-1);
			minutesUnitContainer.innerHTML = minutes == 1 ? "Minute" : "Minuten";

			// display seconds if "minutes" is zero
			if(minutes == 0) {
				minutesFirstDigitContainer.innerHTML = seconds.slice(0,1);
				minutesLastDigitContainer.innerHTML = seconds.slice(-1);
				minutesUnitContainer.innerHTML = seconds == 1 ? "Sekunde" : "Sekunden";
			}
		}

		/**
		 * Timer Callback function triggerd by interval
		 */
		function timerCallback() {
			console.log("Timer");
			now += tickInterval; // increment the current time since last tick
			distance = countDownDate - now;
			refreshTimerView();

			if(restartTimer == true) {
				console.log("restart timer");
				restartTimer = false;
				clearInterval(intervalID);
				tickInterval = 60000 // Set Interval to every 60 second;
				intervalID = window.setInterval(timerCallback, tickInterval);
			}

			// set time values for respective div container
			if(distance > 0 ) {
				if(distance <= 61000 && lastSecondTimer == true) {
					console.log("Trigger Second Interval: " + distance)
					lastSecondTimer = false;
					clearInterval(intervalID);
					tickInterval = 1000;
					intervalID = window.setInterval(timerCallback, tickInterval);
				}
			} else {
				// stop ticking when timer reaches zero
				console.log("Stop Timer: " + distance);
				clearInterval(intervalID);
			}
		}

		/**
		 * Add eventhandler when window get foccus again to retrigger the counter
		 */
		window.addEventListener("focus", function() {
			if(distance > 0) {
				clearInterval(intervalID);
				intervalID = window.setInterval(timerCallback, tickInterval);
			}
		}, false);

		/**
		 * @description adds a leading zero to a number
		 *
		 * @returns integer
		 */
		function pad2(number) {
			return (number < 10 ? '0' : '') + number
		}
	}
	console.info("Laden JS-File Spielschein durchgeführt");
}(jQuery));